import * as React from 'react';

function SvgJoiningBonus(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={28.988} height={31.522} {...props}>
      <defs>
        <style>
          {'.joining_bonus_svg__cls-2{fill:#44c086}.joining_bonus_svg__cls-3{fill:#3ba673}'}
        </style>
      </defs>
      <g id="joining_bonus_svg__cash-payment" transform="translate(-72 -24)">
        <path
          id="joining_bonus_svg__Path_7788"
          fill="#379a6b"
          d="M94.9 55.953l-2.249.7-1.943.608H80.5l-1.983-6.336L72 30.091l6.522-2.041 6.963-2.179 7.167 22.9z"
          transform="translate(0 -1.743)"
        />
        <path
          id="joining_bonus_svg__Path_7789"
          d="M134.189 97.515l.487 1.556-6.224 1.948-.487-1.556-1.556.487-7.143-22.821 1.556-.487-.487-1.556 6.224-1.948.487 1.556 1.556-.487 7.143 22.821z"
          className="joining_bonus_svg__cls-2"
          transform="translate(-44.055 -45.8)"
        />
        <path
          id="joining_bonus_svg__Path_7790"
          d="M168 24h14.13v31.522H168z"
          className="joining_bonus_svg__cls-3"
          transform="translate(-89.478)"
        />
        <path
          id="joining_bonus_svg__Path_7791"
          d="M208.152 81.544v1.63h-6.522v-1.63H200V57.63h1.63V56h6.522v1.63h1.63v23.914z"
          className="joining_bonus_svg__cls-2"
          transform="translate(-119.304 -29.826)"
        />
        <circle
          id="joining_bonus_svg__Ellipse_1327"
          cx={3}
          cy={3}
          r={3}
          className="joining_bonus_svg__cls-3"
          transform="translate(82.5 36.761)"
        />
        <path
          id="joining_bonus_svg__Path_7792"
          fill="#f5cbaa"
          d="M263.887 185.762l-3.723 3.978h-4.07a5.435 5.435 0 01-5.435-5.435h.011l-3.526-5.218a2.174 2.174 0 113.6-2.434l3.173 4.391h1.63V168l4.092 7.673c.172.315 4.248 9.727 4.248 10.089z"
          transform="translate(-162.899 -134.217)"
        />
      </g>
    </svg>
  );
}

export default SvgJoiningBonus;
